import { html } from "lit";
import { getDummyText, getPlaceholderUrl } from "../../../../utils";

interface TemplateArgs {
    headline: string;
    text: string;
    ctaLabel: string;
}

export const Template = ({ headline, text, ctaLabel }: TemplateArgs) => html`
    <ux-iws-nb-product-header>
        <picture slot="image">
            <source
                media="(max-width: 1023px)"
                data-srcset="./mock-assets/nimbus/product-header-3-2.jpg"
            />
            <source
                media="(min-width: 1024px)"
                data-srcset="./mock-assets/nimbus/product-header-3-1.jpg"
            />
            <img
                class="lazyload"
                alt="Product image with 3:2 aspect ratio for mobile and 3:1 for desktop"
                src=${getPlaceholderUrl(1920, 640)}
            />
        </picture>
        <picture slot="zoom-image">
            <img
                data-src="./mock-assets/nimbus/product-header-3-2@2x.jpg"
                alt="Hires product image with 3:2 aspect ratio (zoomed)"
            />
        </picture>
        <h1 slot="headline">${headline}</h1>
        <p slot="text">${text}</p>
        <div slot="cta">
            <ux-button
                variant="primary"
                href="#"
                icon="arrow-small-right"
                icon-placement="end"
                aria-label="${ctaLabel}"
            >
                ${ctaLabel}
            </ux-button>
        </div>
    </ux-iws-nb-product-header>
`;

export const templateArgs: TemplateArgs = {
    headline: "TruFiber 6000 S",
    text: getDummyText(200),
    ctaLabel: "Kontakt aufnehmen",
};
